import React from 'react'
import { INTERVALO_CORTO } from '../../../../config/settings'
import { ToastContainer } from 'react-toastify'
import RechazoBrutoView from './RechazoBrutoView'
import { connect } from 'react-redux'
import { FORM_PESO_BRUTO } from '../../../../config/forms'
import { formValueSelector } from 'redux-form'

function RechazoBruto (props) {
  const { numero = null } = props

  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <RechazoBrutoView numero={numero} />
    </>
  )
}

const selector = formValueSelector(FORM_PESO_BRUTO)

const mapStateToProps = (state) => ({
  motivoRechazo: selector(state, 'motivoRechazo')
})

const withRedux = connect(mapStateToProps, null)

export default withRedux(RechazoBruto)
